(function () {
  function fixSalePriceCards() {
    var cards = document.querySelectorAll('.card-information, .card__information, .product-card__content, .product-grid__card, .resource-card');

    cards.forEach(function (card) {
      var price = card.querySelector('.price');
      if (!price) return;

      var sale = price.querySelector('.price-item--sale');
      var compare = price.querySelector('.price-item--regular, s');

      if (!sale || !compare) return;

      price.classList.add('gh-exact-sale-price-fixed');
      
      // Ensure parent allows full width spanning
      price.style.width = '100%';

      sale.style.color = '#d60000';
      sale.style.textDecoration = 'none';
      sale.style.background = 'transparent';
      sale.style.justifySelf = 'end';
      sale.style.textAlign = 'right';
      // Force right alignment in flex/block layouts
      sale.style.width = '100%';
      sale.style.display = 'block';
      sale.style.marginLeft = 'auto';

      compare.style.color = '#6f6f6f';
      compare.style.textDecoration = 'line-through';
      compare.style.justifySelf = 'end';
      compare.style.textAlign = 'right';
      // Force right alignment in flex/block layouts
      compare.style.width = '100%';
      compare.style.display = 'block';
      compare.style.marginLeft = 'auto';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSalePriceCards);
  } else {
    fixSalePriceCards();
  }

  document.addEventListener('shopify:section:load', fixSalePriceCards);
})();